import actionTypes from 'constants/publishersConstants';
import { buildPackageParams } from './checkoutDataActions';

function addLocationAndCategoryParams(getState, params){
  const formState = getState().form.eventSubmission.values;
  params['latitude'] = formState.venue.lat;
  params['longitude'] = formState.venue.lng;
  params['country_iso'] = formState.venue.country && formState.venue.country.iso_alpha2;
  params['category_id'] = formState.category_id;
}

function fetchPublishersForEvent(eventId) {
  return (dispatch, getState, api) => {
    const params = buildPackageParams(getState().checkoutData);
    api.get(`/events/${eventId}/publishers`, { params }).then(
      response => dispatch({ type: actionTypes.FETCH_PUBLISHERS_SUCCESS, payload: response.data }),
      error => dispatch({ type: actionTypes.FETCH_PUBLISHERS_FAILURE, payload: error })
    );
  };
}

function fetchPublicPublishers(forSnapSell = false) {
  return (dispatch, getState, api) => {
    const params = buildPackageParams(getState().checkoutData, getState().config);
    if (forSnapSell) {
      addLocationAndCategoryParams(getState,params);
    }

    api.get('/publishers', { params }).then(
      response => dispatch({ type: actionTypes.FETCH_PUBLISHERS_SUCCESS, payload: response.data }),
      error => dispatch({ type: actionTypes.FETCH_PUBLISHERS_FAILURE, payload: error })
    );
  };
}

export function fetchPublishers() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PUBLISHERS_REQUEST });
    const state = getState();
    const snapSellPackageId = state.checkoutData.get('snap_sell_package_id');
    const forSnapSell = state.config.get('snap_sell_enabled') && !snapSellPackageId;
    if (forSnapSell && state.form.eventSubmission.values.venue.place_id) {
      if (!state.form.eventSubmission.values.venue.lat) {
        setTimeout(() => {
          dispatch(fetchPublishers(forSnapSell));
        }, 500);
        return;
      }
    }

    if (state.checkoutData.hasIn(['current_event', 'id'])) {
      dispatch(fetchPublishersForEvent(state.checkoutData.getIn(['current_event', 'id'])));
    } else {
      dispatch(fetchPublicPublishers(forSnapSell));
    }
  };
}

function venueIsGeocoded(venue) {
  return !!venue && venue.lat != null && venue.lng != null;
}

export function checkEventEligibility () {
  return (dispatch, getState, api) => {
    const { venue } = getState().form.eventSubmission.values;
    if (!venueIsGeocoded(venue)) { return; }

    dispatch({ type: actionTypes.FETCH_EVENT_ELIGIBILITY_REQUEST });

    const params = { publisher_id: getState().config.get('publisher_id') };
    addLocationAndCategoryParams(getState, params);
    api.get('/publishers/event_eligibility', { params }).then(
      response => dispatch({ type: actionTypes.FETCH_EVENT_ELIGIBILITY_SUCCESS, payload: response.data }),
      error => dispatch({ type: actionTypes.FETCH_EVENT_ELIGIBILITY_ERROR, payload: error })
    );
  };
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/publishersActions.js